import styled from 'styled-components';

export const DateInputContainer = styled.div`
  * {
    max-width: 186px;
    max-height: 50px;
  }
`;
